/**
 * Each type corresponds to a `<script id="json-ld-{type}">` tag in <head>.
 * - global:     Organization + WebSite (added once on init)
 * - page:       per-page entity (WebPage, SoftwareApplication, CollectionPage, …)
 * - breadcrumb: BreadcrumbList for non-home pages
 * - reviews:    SoftwareApplication stub with nested Review items (used on pages
 *               where the page entity is NOT SoftwareApplication; on SoftwareApplication
 *               pages, reviews are merged into the 'page' block instead)
 * - faq / item-list / from-comp / to-comp: other per-page blocks
 */
export type JsonLDType =
  | 'page'
  | 'global'
  | 'breadcrumb'
  | 'faq'
  | 'item-list'
  | 'from-comp'
  | 'to-comp'
  | 'home-page-extras';

export const jsonLdsToRemoveOnEveryPage: JsonLDType[] = ['page', 'home-page-extras', 'breadcrumb'];
